import React from "react";
import { LOGO_URL } from "@/data/constants";
import { ProgereText } from "@/components/ProgereText";
import { useI18n } from "@/context/I18nContext";
import { Link } from "react-router-dom";

export function Logo({ size = 40, withText = true, to = "/", subtitle = "", className = "" }) {
  const { t } = useI18n();
  const content = (
    <div className={`flex items-center gap-3 ${className}`} data-testid="progere-logo">
      <img
        src={LOGO_URL}
        alt="PROGÈRE"
        style={{ height: size, width: size }}
        className="object-contain drop-shadow-[0_0_12px_rgba(212,175,55,0.35)]"
      />
      {withText && (
        <div className="leading-none">
          <div className="flex items-baseline gap-1.5">
            <ProgereText className="font-extrabold tracking-tight text-xl" />
            {subtitle && (
              <span className="text-white font-semibold text-xl tracking-tight">
                {subtitle}
              </span>
            )}
          </div>
          <span className="text-[10px] uppercase tracking-[0.28em] text-white/40 font-mono">
            {t("common.ecosystem")}
          </span>
        </div>
      )}
    </div>
  );

  if (to) {
    return (
      <Link to={to} className="shrink-0">
        {content}
      </Link>
    );
  }
  return content;
}
